import axios from 'axios';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const addWish = (customerId, allocationId, wish) => {
  const newWish = wish;
  return axios.post(
    `${getV1RootUrl()}/customer/${customerId}/allocation/${allocationId}/wish`,
    newWish,
    axiosHeader()
  );
};
